import * as angular from "angular";
import {IController} from "angular";

export class ResourceCapacityCtrl implements IController {

  resourceCapacity:any;

}
angular
  .module('bringoz.admin.resources')
  .component('resourceCapacity', {
    bindings: {
      resourceCapacity: '<'
    },
    template: require('./resource-capacity.html').default,
    controller: ResourceCapacityCtrl
  });
